import { lazy } from "react";
import Loadable from "app/components/Loadable";
import config from "app/services/endpoints";

const NotFound = Loadable(lazy(() => import("app/pages/NotFound")));

const { react_Login_With_url } = config.react_loging;

const LoginAzure = Loadable(lazy(() => import("app/pages/auth/AzureLogin")));
const LoginDefault = Loadable(lazy(() => import("app/pages/auth/Login")));

const LoginComponent = react_Login_With_url === "azure" ? LoginAzure : LoginDefault;

const sessionRoutes = [
  { path: "/session/signin", element: <LoginComponent /> },
  { path: "*", element: <NotFound /> }
];

export default sessionRoutes;
